import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowRight, PartyPopper } from "lucide-react";
import ReferralLeaderboardHook from "@/components/ReferralLeaderboardHook";

export default function PostSignupReferralModal({ open, onContinue }) {
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          className="fixed inset-0 z-[110] bg-black/70 backdrop-blur-sm flex items-center justify-center px-6"
          data-testid="post-signup-referral-modal"
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.95, y: 12 }} animate={{ opacity: 1, scale: 1, y: 0 }} exit={{ opacity: 0, scale: 0.95 }}
            className="glass-panel rounded-2xl max-w-lg w-full p-6 sm:p-7 border border-white/10"
          >
            <div className="flex items-center gap-2 mb-1">
              <PartyPopper className="w-5 h-5 text-amber-400" />
              <span className="text-xs font-bold uppercase tracking-[0.2em] text-amber-400">Welcome to Cloudivo</span>
            </div>
            <h2 className="font-heading text-xl font-semibold text-white mt-1">You're in! Day 1 is unlocked.</h2>
            <p className="text-sm text-slate-400 mt-1.5">Before you start — grab your referral link. Friends who join with it get you both bonus XP, right from day one.</p>

            <div className="mt-5">
              <ReferralLeaderboardHook compact />
            </div>

            <button
              onClick={onContinue} data-testid="post-signup-continue-btn"
              className="mt-5 w-full flex items-center justify-center gap-2 bg-primary hover:bg-primary/90 text-white font-semibold py-3 rounded-xl transition-all hover:-translate-y-0.5"
            >
              Continue to Day 1 <ArrowRight className="w-4 h-4" />
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
